import { Routes, UrlMatchResult, UrlSegment } from '@angular/router';

import { IndexComponent } from './routes/index/index.component';
import { CigClaimComponent } from './routes/cigclaim/cigclaim.component';
import { StatusComponent } from './routes/status/status.component';
import { NotificationsComponent } from './routes/notifications/notifications.component';
import { MarketComponent } from './routes/market/market.component';
import { DashboardComponent } from './routes/dashboard/dashboard.component';
import { ItemViewComponent } from './routes/item-view/item-view.component';
import { AuctionComponent } from './routes/auction/auction.component';

const marketRouteMatcher = (url: UrlSegment[]): UrlMatchResult | null => {
  if (url.length === 1) {
    return {
      consumed: url,
      posParams: {
        marketType: url[0]
      }
    };
  }

  if (url.length === 3 && url[1].path === 'detail') {
    return {
      consumed: url,
      posParams: {
        marketType: url[0],
        bidId: url[2]
      }
    };
  }

  return null;
};

/** Eager routes for IPFS/static builds — avoids runtime chunk loading on gateways. */
export const routes: Routes = [
  { path: '', component: IndexComponent },
  { path: 'cigclaim', component: CigClaimComponent },
  { path: 'status', component: StatusComponent },
  { path: 'notifications', component: NotificationsComponent },
  { matcher: marketRouteMatcher, component: MarketComponent },
  { path: 'user/:address', component: DashboardComponent },
  { path: 'details/:tokenId', component: ItemViewComponent },
  { path: 'auction/:auctionId', component: AuctionComponent },
];
